import React, { Component } from "react";
import Cookie from 'js-cookie';
import "./Admin.css";
import background from "../img/mamca-bg.jpg";
// import { Link } from "react-router-dom";
import {
  Form, Icon, Input, Button, message
} from 'antd';


class Admin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isAuthenticated: Cookie.get("isAuthenticated") || false, //get cookie if authenticated
      loading: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault(); //prevent default function
    this.props.form.validateFields((err, values) => {
      //if there is no error do the login step
      if (!err) {
        //console.log('Received values of form: ', values);
        this.setState({ loading: true });
        if(values.username === "admin" && values.password === "MAMCAAdmin!"){
            message.success('Login success') //show message
            Cookie.set('admin', true, { expires: 1/48 });//expire in 30 mins
            this.props.history.push("/adminhome"); //redirect to homepage
        }
        else {
            message.error('Wrong username or password') //show message of error
            Cookie.remove('email');
          }
        this.setState({ loading: false }); //cancel loading status     
      }
    });
    //console.log(this.props.form.getFieldsValue())
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      // set background image
      <div style={{ backgroundImage: "url(" + background + ")" }} className="Login">
        <div className="Mamca-welcome">
          <h1 style={{ color: "white" }}>
            MAMCA Administration
      </h1>
          {/* <h3 style={{ color: "white" }}>
            Administration
      </h3> */}
        </div>
        {/* fomr of login */}
        <Form onSubmit={this.handleSubmit} className="login-form">
          <Form.Item>
            {getFieldDecorator('username', {
              rules: [{ required: true, message: 'Please input your user name!' }],
            })(
              <Input prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} size="large" placeholder="username" />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }],
            })(
              <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" size="large" placeholder="Password" />
            )}
          </Form.Item>
          <Form.Item>
            {/* {getFieldDecorator('remember', {
              valuePropName: 'checked',
              initialValue: false,
            })(
              <Checkbox>Remember me</Checkbox>
            )} */}
            {/* forget function can be used later */}
            {/* <a className="login-form-forgot" href="">Forgot password</a> */}
            <Button
              size="large"
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              loading={this.state.loading}>
              Log in as Administrator
          </Button>
            {/* Or
          <Link to="/signup">
              <b style={{ color: "rgba(0, 0, 0, 1 )" }}> register now!</b>
            </Link>
            <Popconfirm title="It will send your password to your email, are you sure?" onConfirm={() => { this.sendPassword(this.props.form.getFieldValue('email'))}} okText="Yes" cancelText="No">
              <Link style = {{float: "right" }} to="#">
                <b style={{ color: "rgba(0, 0, 0, 1 )"}}> Forget password?</b>
              </Link>
            </Popconfirm> */}
          </Form.Item>
        </Form>
      </div>
    );
  }
}
Admin = Form.create({})(Admin); //create form which can access the data
export default Admin;
